import type { LoaderFunction } from 'react-router-dom';
import { apiGetCards } from '../api/cardApi';
import type { Card } from '../types/models/card';

export const CardsListLoader: LoaderFunction = async () => {
  if (window.innerWidth < 768) return null;
  const data = await apiGetCards();
  const cards: Card[] = Array.isArray(data) ? data : (data as any).data ?? [];
  return cards;
};
